import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/404.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "inner-main-content" }
const _hoisted_3 = { class: "card border-0 box-shadow border-radius-10 mb-4" }
const _hoisted_4 = { class: "card-body px-4 py-5" }
const _hoisted_5 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_0,
              class: "mb-4",
              alt: "starter-img"
            }, null, -1)),
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "fs-30 fw-medium mb-1" }, "Not Found", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-body mb-4" }, " Sorry, what you are looking for cannot be found. ", -1)),
            _createVNode(_component_router_link, {
              to: "/",
              class: "default-btn text-decoration-none text-white"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Back To Home ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_MainFooter)
    ])
  ]))
}